import LockIcon from '@mui/icons-material/Lock';
import LockOpenIcon from '@mui/icons-material/LockOpen';
import Button from '@mui/material/Button';
import FormControlLabel from '@mui/material/FormControlLabel';
import IconButton from '@mui/material/IconButton';
import Switch from '@mui/material/Switch';

type AccessibilityMuiSwitchProps = {
  value: boolean;
  setValue: (value: boolean) => void;
  label?: string;
  checkedLabel?: string;
  hideLabel?: boolean;
  id: string;
  config: { settings: { renderSize?: string } };
  type: string;
};

export default function AccessibilityMuiSwitch({
  value,
  setValue,
  label,
  checkedLabel,
  hideLabel,
  id,
  type,
}: AccessibilityMuiSwitchProps) {
  const onChange = (e: React.ChangeEvent<HTMLInputElement>) => setValue(e.target.checked);
  const onClick = () => setValue(!value);
  const postfix = type;
  const showLabel = value ? (checkedLabel || label) : label;
  const icon = value ? <LockIcon /> : <LockOpenIcon />;

  if (type === 'lock') {
    if (hideLabel) {
      return (
        <IconButton
          key={`${id}${postfix}`}
          onClick={onClick}
          size="small"
          aria-label="Toggle lock"
        >
          {icon}
        </IconButton>
      );
    }
    return (
      <Button key={`${id}${postfix}`} onClick={onClick} size="small" startIcon={icon}>
        {showLabel}
      </Button>
    );
  }

  return (
    <FormControlLabel
      control={
        <Switch checked={!!value} size="small" onChange={onChange} />
      }
      label={showLabel}
    />
  );
}
